<div
  class="login-container d-flex justify-content-center align-items-center gap-5"
  [style.background-image]="'url(' + ('login-registrations/login-image.jpeg' | contentAssetImage) + ')'"
>
  <div class="card">
    <img class="logo" draggable="false" [src]="'login-registrations/hawks-login-logo.png' | contentAssetImage" />
    <div
      class="text-white font-size-14 login-desc mb-4"
      [innerHTML]="'login.text.description' | translate | markdownTranslate"
    ></div>
    <ng-container>
      <div class="btn-login">
        <fgb-tm-user-login></fgb-tm-user-login>
      </div>
    </ng-container>
  </div>
</div>
